import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { lazy, Suspense } from 'react';
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

// Eager load critical pages
import HomePage from "@/pages/HomePage";

// Lazy load secondary pages for code splitting
const QuotePage = lazy(() => import("@/pages/QuotePage"));
const ServicesPage = lazy(() => import("@/pages/ServicesPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const CaseStudiesPage = lazy(() => import("@/pages/CaseStudiesPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const FAQPage = lazy(() => import("@/pages/FAQPage"));
const PrivacyPage = lazy(() => import("@/pages/PrivacyPage"));
const TermsPage = lazy(() => import("@/pages/TermsPage"));

// Loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50">
    <div className="spinner"></div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Main Pages - SEO Optimized */}
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/quote" element={<QuotePage />} />
          <Route path="/faq" element={<FAQPage />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/terms-of-service" element={<TermsPage />} />
          
          {/* 404 - Catch all */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </Suspense>
      <FloatingWhatsApp />
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
